import React from 'react';
import './pdf.css'; // CSS dosyasını ayrı oluşturacağız

const BootcampGuide = () => {
    const downloadPDF = () => {
        window.print();
    };

    return (
        <div className="bootcamp-guide">
            <div className="container">
                {/* Header */}
                <header className="header">
                    <div className="logo-container">
                        <img src={process.env.PUBLIC_URL + "/images/TELEFERIC.png"} alt="Teleferic House" className="company-logo" />
                    </div>
                    <h1>🐍 Python & Data Science Bootcamp</h1>
                    <p>8 Haftalık Kapsamlı Eğitim Programı</p>
                    <div className="company-info">
                        <h3>📚 Teleferic House Profesyonel Gelişim Programı</h3>
                        <p>Sıfırdan uzmanlığa Python, Veri Bilimi ve Yapay Zeka</p>
                    </div>
                </header>
                
                {/* PDF Download Button */}
                <button className="pdf-download-btn" onClick={downloadPDF}>
                    <span>📄</span>
                    <span>PDF İndir</span>
                </button>

                {/* Content */}
                <main className="content">
                    {/* Genel Bilgi */}
                    <section id="genel-bilgi" className="section">
                        <h2>📊 Bootcamp Hakkında</h2>
                        
                        <div className="stats-grid">
                            <div className="stat-card">
                                <span className="stat-number">8</span>
                                <span className="stat-label">Hafta Eğitim</span>
                            </div>
                            <div className="stat-card">
                                <span className="stat-number">6</span>
                                <span className="stat-label">Saat/Hafta</span>
                            </div>
                            <div className="stat-card">
                                <span className="stat-number">10+</span>
                                <span className="stat-label">Proje</span>
                            </div>
                            <div className="stat-card">
                                <span className="stat-number">100%</span>
                                <span className="stat-label">Uygulamalı</span>
                            </div>
                        </div>

                        <div className="card-grid">
                            <div className="card">
                                <div className="card-icon">🎯</div>
                                <h3>Hedef Kitle</h3>
                                <p>Programlama deneyimi olan veya olmayan, veri bilimi ve yapay zeka alanında kariyer yapmak isteyen profesyoneller.</p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">🏆</div>
                                <h3>Sertifikasyon</h3>
                                <p>Başarıyla tamamlayan katılımcılara uluslararası geçerliliği olan sertifika verilecektir.</p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">👥</div>
                                <h3>Mentörlük</h3>
                                <p>Uzman eğitmenler tarafından birebir mentörlük ve kariyer danışmanlığı hizmeti.</p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">💼</div>
                                <h3>İş Garantisi</h3>
                                <p>Başarılı mezunlarımız için iş bulma garantisi ve network oluşturma imkanı.</p>
                            </div>
                        </div>
                    </section>

                    {/* Kazanımlar */}
                    <section id="kazanimlar" className="section">
                        <h2>🎯 Eğitim Kazanımları</h2>
                        
                        <div className="outcome-list">
                            <div className="outcome-item">
                                <h4>🐍 Python Programlama</h4>
                                <p>Temel syntax'tan ileri seviye programlamaya kadar Python'da uzmanlaşma</p>
                            </div>
                            
                            <div className="outcome-item">
                                <h4>📊 Veri Analizi</h4>
                                <p>NumPy, Pandas ile veri manipülasyonu ve analiz yetenekleri</p>
                            </div>
                            
                            <div className="outcome-item">
                                <h4>📈 Veri Görselleştirme</h4>
                                <p>Matplotlib, Seaborn ile profesyonel grafik ve dashboard oluşturma</p>
                            </div>
                            
                            <div className="outcome-item">
                                <h4>🤖 Makine Öğrenmesi</h4>
                                <p>Scikit-learn ile ML algoritmaları ve model geliştirme</p>
                            </div>
                            
                            <div className="outcome-item">
                                <h4>🧠 Yapay Zeka</h4>
                                <p>NLP, Computer Vision ve derin öğrenme projelerinde uzmanlaşma</p>
                            </div>
                            
                            <div className="outcome-item">
                                <h4>🌐 Web Geliştirme</h4>
                                <p>FastAPI ile modern web servisleri ve API geliştirme</p>
                            </div>
                            
                            <div className="outcome-item">
                                <h4>🔧 DevOps & Dağıtım</h4>
                                <p>Git, Docker ve cloud platformlarda proje yayınlama</p>
                            </div>
                            
                            <div className="outcome-item">
                                <h4>💾 Veritabanı Yönetimi</h4>
                                <p>SQL ve NoSQL veritabanlarında uzmanlaşma</p>
                            </div>
                        </div>
                    </section>

                    {/* Program */}
                    <section id="program" className="section">
                        <h2>📅 8 Haftalık Eğitim Programı</h2>
                        
                        <div className="week-timeline">
                            {[
  {
    "week": 1,
    "title": "🚀 Git, GitHub & Python Temelleri",
    "topics": [
      "Git, GitHub ve Cursor tanıtımı",
      "commit, branch, merge, push–pull mantığı",
      "Python kurulumu, terminal ve Jupyter kullanımı",
      "Temel komutlar: print(), input(), type(), int(), float(), str(), len()",
      "Değişkenler, veri tipleri, operatörler",
      "Karar yapıları (if–elif–else)",
      "Döngüler: range(), enumerate(), break & continue",
      "Temel veri yapıları: list, tuple, dict, set",
    ]
  },
  {
    "week": 2,
    "title": "⚙️ Fonksiyonlar, Hata Yönetimi ve Dosya İşlemleri",
    "topics": [
      "Fonksiyon tanımı, çağırma, parametre, argüman, return",
      "Scope: global vs local değişkenler",
      "Lambda ifadeleri, map–filter–reduce kullanımı",
      "Try–Except yapısı ve hata türleri (SyntaxError, TypeError, ValueError)",
      "Dosya işlemleri: open, read, write",
      "JSON ve CSV dosyalarıyla çalışma"
    ]
  },
  {
    "week": 3,
    "title": "🏗️ OOP (Nesne Yönelimli Programlama) & Modül Yönetimi",
    "topics": [
      "Class ve nesne kavramı (_init, self, __str_)",
      "Kalıtım (inheritance), çok biçimlilik (polymorphism), kapsülleme",
      "Modül yapısı ve kendi modülünü oluşturma",
      "Hazır kütüphaneler: os, math, datetime, random",
      "Virtual environment (venv) kullanımı",
      "pip ve PyPI kullanımı"
    ]
  },
  {
    "week": 4,
    "title": "📊 Veri Bilimi Temelleri (NumPy & Pandas)",
    "topics": [
      "NumPy kütüphanesiyle array işlemleri",
      "Pandas DataFrame ve Series yapısı",
      "Veri okuma/yazma: CSV, JSON, Excel",
      "Veri temizleme ve preprocessing işlemleri"
    ]
  },
  {
    "week": 5,
    "title": "📈 Veri Görselleştirme & API Kullanımı",
    "topics": [
      "Matplotlib: line, bar, scatter, histogram, pie chart",
      "Renk ve tema ayarları",
      "Seaborn ile estetik grafikler",
      "API kavramı, REST prensipleri",
      "requests kütüphanesiyle API’den veri çekme",
      "Gerçek dünya API örnekleri: hava durumu, döviz, film verileri"
    ]
  },
  {
    "week": 6,
    "title": "🌐 FastAPI ile Web Servisleri",
    "topics": [
      "FastAPI nedir",
      "Uygulama oluşturma ve endpoint tanımlama",
      "GET, POST, PUT, DELETE işlemleri",
      "Path ve query parametreleri",
      "Form-data ve JSON istekleri",
      "Pydantic modelleri",
      "Postman kullanımı"
    ]
  },
  {
    "week": 7,
    "title": "👁️ Görüntü İşleme (OpenCV)",
    "topics": [
      "OpenCV kurulumu ve temel işlemler",
      "Görüntü okuma, gösterme, kaydetme",
      "Renk uzayları (RGB, HSV, GRAY)",
      "Filtreleme ve thresholding",
      "Yüz algılama (Haar Cascade)",
      "Nesne tespiti için önceden eğitilmiş modeller",
      "Video akışı (kamera feed) ile çalışma"
    ]
  },
  {
    "week": 8,
    "title": "🤖 NLP & Mini AI Projeleri",
    "topics": [
      "NLP temelleri: Tokenization, Lemmatization, Stopwords",
      "nltk ve spaCy kütüphaneleri",
      "Metin sınıflandırma ve duygu analizi",
      "Hugging Face modellerine giriş",
      "Pretrained modelleri yükleme",
      "Streamlit ile AI arayüzü oluşturma",
      "Chatbot veya duygu analizi mini projesi"
    ]
  }
].map((weekData) => (
                                <div key={weekData.week} className="week-item">
                                    <div className="week-number">{weekData.week}</div>
                                    <div className="week-content">
                                        <div className="week-title">{weekData.title}</div>
                                        <ul className="week-topics">
                                            {weekData.topics.map((topic, index) => (
                                                <li key={index}>{topic}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    {/* Detaylar */}
                    <section id="detaylar" className="section">
                        <h2>📖 Eğitim Detayları</h2>
                        
                        <div className="card-grid">
                            <div className="card">
                                <div className="card-icon">⏰</div>
                                <h3>Eğitim Saatleri</h3>
                                <p>
                                    <strong>Hafta sonu:</strong> 19:00 - 22:00<br/>
                                    <strong>Toplam:</strong> 48 - 54 saat eğitim
                                </p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">💻</div>
                                <h3>Teknik Gereksinimler</h3>
                                <p>
                                    <strong>İşletim Sistemi:</strong> Windows/Mac/Linux<br/>
                                    <strong>RAM:</strong> Minimum 8GB<br/>
                                    <strong>İnternet:</strong> Stabil bağlantı<br/>
                                    <strong>IDE:</strong> VS Code (ücretsiz)
                                </p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">🎥</div>
                                <h3>Eğitim Formatı</h3>
                                <p>
                                    <strong>Canlı Dersler:</strong> Zoom üzerinden<br/>
                                    <strong>Kayıtlar:</strong> 7/24 erişim<br/>
                                    <strong>Lab Saatleri:</strong> Uygulamalı çalışma<br/>
                                    <strong>Q&A:</strong> Haftalık soru-cevap
                                </p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">📝</div>
                                <h3>Değerlendirme</h3>
                                <p>
                                    <strong>Ödevler:</strong> %40<br/>
                                    <strong>Projeler:</strong> %40<br/>
                                    <strong>Final Projesi:</strong> %20<br/>
                                    <strong>Geçme Notu:</strong> 70/100
                                </p>
                            </div>
                        </div>

                        <div style={{ marginTop: '40px' }}>
                            <h3 style={{ color: '#667eea', marginBottom: '20px' }}>🛠️ Kullanılacak Teknolojiler</h3>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px' }}>
                                {[
                                    'Python 3.9+', 'Jupyter Notebook', 'NumPy & Pandas', 'Matplotlib & Seaborn',
                                    'FastAPI', 'OpenCV', 'Hugging Face', 'Git & GitHub', 'VS Code', 'Postman'
                                ].map((tech, index) => (
                                    <span 
                                        key={index}
                                        style={{ 
                                            background: '#667eea', 
                                            color: 'white', 
                                            padding: '8px 16px', 
                                            borderRadius: '20px', 
                                            fontSize: '0.9rem' 
                                        }}
                                    >
                                        {tech}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Başvuru */}
                    <section id="basvuru" className="section">
                        <h2>✉️ Başvuru Bilgileri</h2>
                        
                        <div className="card-grid">
                            <div className="card">
                                <div className="card-icon">💰</div>
                                <h3>Ücret Bilgileri</h3>
                                <p>
                                    <strong>Erken Kayıt:</strong> ₺9,000 (İlk 20 kişi)<br/>
                                    <strong>Normal Ücret:</strong> ₺10,000<br/>
                                    <strong>Taksit:</strong> 6 aya kadar vade<br/>
                                    <strong>Kurumsal:</strong> %20 indirim
                                </p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">📅</div>
                                <h3>Önemli Tarihler</h3>
                                <p>
                                    <strong>Başvuru Açılış:</strong> 25 Aralık 2025<br/>
                                    <strong>Erken Kayıt Son:</strong> 15 Kasım 2025<br/>
                                    <strong>Başvuru Son:</strong> 30 Kasım 2025<br/>
                                    <strong>Eğitim Başlangıç:</strong> 15 Aralık 2025
                                </p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">📋</div>
                                <h3>Başvuru Koşulları</h3>
                                <p>
                                    <strong>Yaş:</strong> 16-55 arası<br/>
                                    <strong>Eğitim:</strong> Lise mezunu<br/>
                                    <strong>Deneyim:</strong> Gerekli değil<br/>
                                    <strong>İngilizce:</strong> Temel seviye
                                </p>
                            </div>
                            
                            <div className="card">
                                <div className="card-icon">🎁</div>
                                <h3>Bootcamp Avantajları</h3>
                                <p>
                                    <strong>Materyal:</strong> Tüm kaynaklar ücretsiz<br/>
                                    <strong>Sertifika:</strong> Uluslararası geçerli<br/>
                                    <strong>Garanti:</strong> %100 para iade
                                </p>
                            </div>
                        </div>

                        <div style={{ 
                            background: 'linear-gradient(135deg, #667eea, #764ba2)', 
                            color: 'white', 
                            padding: '40px', 
                            borderRadius: '20px', 
                            textAlign: 'center', 
                            marginTop: '40px' 
                        }}>
                            <h3 style={{ fontSize: '2rem', marginBottom: '20px' }}>🚀 Hemen Başvur!</h3>
                            <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>Sınırlı kontenjan! Yerini şimdi ayırt.</p>
                            <p style={{ fontSize: '1rem', marginBottom: '30px', opacity: '0.9' }}>
                                💳 Ödeme ve başvuru: <strong>learninghell.com</strong><br/>
                                🏢 Teleferic House güvencesiyle
                            </p>
                        </div>
                    </section>
                </main>

                {/* Footer */}
                <footer className="footer">
                    <div className="footer-logo">
                        <img src={process.env.PUBLIC_URL + "/images/TELEFERIC.png"} alt="Teleferic House" className="footer-company-logo" />
                    </div>
                    <h3>📞 İletişim Bilgileri</h3>
                    <div className="contact-info">
                        <div className="contact-item">
                            <span>📧</span>
                            <span>education@learninghell.com</span>
                        </div>
                        <div className="contact-item">
                            <span>📱</span>
                            <span>+90 5310149046</span>
                        </div>
                        <div className="contact-item">
                            <span>🌐</span>
                            <span>www.learninghell.com</span>
                        </div>
                    </div>
                    <p style={{ marginTop: '30px', opacity: '0.8' }}>© 2025 Teleferic House. Tüm hakları saklıdır.</p>
                </footer>
            </div>
        </div>
    );
};

export default BootcampGuide;

